import { UserItemProps } from "apis/user";
import axios from "axios";
import { store } from "store";
import { authChecked } from "store/auth";
import { OutputBaseProps } from "utils/types/API";
import { apiAuthPermission } from "./auth-permission";

type ApiCheckOutputProps = OutputBaseProps<{ user: UserItemProps }>;

export const apiAuthCheck = async () => {
    const res = (await axios.post<ApiCheckOutputProps>("/api/auth/check"))
        .data;
    if (res.code === 0 && res.data) {
        const authPermission = await apiAuthPermission()
        const tokenLocalStorge = localStorage.getItem("token");

        store.dispatch(authChecked({
            ...res.data,
            token: tokenLocalStorge || undefined,
            permissions: authPermission.data || []
        }));
    }
    return res;
};
